// store/error/errorActions.js
import { SHOW_ERROR, CLEAR_ERROR } from './actions';

export const showError = (error) => ({
  type: SHOW_ERROR,
  payload: error
});

export const clearError = () => ({
  type: CLEAR_ERROR
});



export const initialState = {
  error: null
};

// ==============================|| ERROR REDUCER ||============================== //

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ERROR: {
      return {
        ...state,
        error: action.payload
      };
    }
    case CLEAR_ERROR: {
      return {
        ...state,
        error: null
      };
    }
    default:
      return state;
  }
};

export default errorReducer;
